import React, {forwardRef} from 'react';

interface Props {
  id: string;
  children: React.ReactNode;
}

const FormCard = forwardRef<HTMLDivElement, Props>(function FormCard(
  {id, children},
  ref
): React.ReactElement {
  return (
    <div id={id} className="portfolio-form-card" ref={ref}>
      {children}
    </div>
  );
});

export default FormCard;
